<template>
  <v-dialog
    scrollable
    width="463"
    :value="showDialog"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-card-title class="mb-2">{{ teamName }}</v-card-title>
      <v-card-subtitle
        v-text="
          $t('teams.memberWithCount', {
            count: teamMembers.length,
          })
        "
      />
      <v-card-text class="pb-0 px-0">
        <v-list>
          <template v-for="(member, index) in teamMembers">
            <v-list-item
              class="px-6"
              link
              :key="member._id"
              :disabled="member.id === profileAccountId"
              :to="{
                path: `/profile/${member.organization}/${member._id}`,
              }"
            >
              <UserAvatar
                size="32px"
                fontSize="12px"
                class="me-2"
                :account="member"
              />
              <v-list-item-content>
                <v-list-item-title
                  class="grey--text text--darken-4"
                  v-text="getFullName(member)"
                >
                </v-list-item-title>
                <v-list-item-subtitle
                  class="grey--text text-body-2"
                  v-text="member.email"
                >
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-chip
                v-if="index === 0"
                pill
                small
                color="teal teal--text"
                outlined
              >
                {{
                  member.id === currentAccountId
                    ? $t('teams.leading')
                    : $t('teams.leader_one')
                }}
              </v-chip>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions class="pr-6 pb-4 pt-0">
        <v-spacer></v-spacer>
        <Button
          color="primary"
          :text="$t('common.button.close')"
          @click="closeDialog"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import _ from 'lodash'
import Button from '@/components/UI/Button'
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'Teams',

  mixins: [mixin],

  props: {
    team: {
      type: Object,
      required: true,
    },
    showDialog: {
      type: Boolean,
      required: true,
    },
    profileAccountId: {
      type: String,
      required: true,
    },
  },

  components: {
    UserAvatar,
    Button,
  },

  computed: {
    currentAccountId() {
      return this.getAccountId()
    },

    myAccountId() {
      return this.getAccountId()
    },

    teamMembers() {
      return !_.isEmpty(this.team)
        ? [...this.team.leaders, ...this.team.members]
        : []
    },

    teamName() {
      return this.team?.name ?? ''
    },
  },

  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
  },
}
</script>
